<template>
    <div v-if="product.status || product.waiting_list" class="product-card">
        <a :data-id="product.id"
           :href="product.url"
           class="product-card-item"
           @mouseleave="mouseLeave"
           @mouseover="mouseOver">
            <div v-if="lazyLoad" v-touch-swipe.right.left="swipe" class="product-card-images">
                <div v-if="product.images[0]"
                     :class="[{'first': !toggleImage, 'images': product.images.length > 1}]"
                     class="product-card-img-wrapper">
                    <img :alt="product.name + ' ' + product.article"
                         :class="{'hidden': toggleImage}"
                         :data-src="product.images[0]"
                         class="lazyload product-card-img"
                         height="346"
                         loading="lazy"
                         :src="lazyLoad ? '' : product.images[0]"
                         width="240"
                    />
                </div>
                <div v-else class="product-card-img-wrapper">
                    <img :alt="product.name + ' ' + product.article"
                         class="product-card-img"
                         height="346"
                         src=""
                         width="240"
                    />
                </div>
                <div v-if="product.images[1]"
                     :class="[{'second': toggleImage, 'images': product.images.length > 1}]"
                     class="product-card-img-wrapper">
                    <img :alt="product.name + ' ' + product.article"
                         :class="{'hidden': !toggleImage}"
                         :data-src="product.images[1]"
                         :loading="lazyLoad ? 'lazy' : ''"
                         class="lazyload product-card-img"
                         height="346"
                         :src="lazyLoad ? '' : product.images[1]"
                         width="240"
                    />
                </div>
            </div>
            <div v-else v-touch-swipe.right.left="swipe" class="product-card-images">
                <div v-if="product.images[0]"
                     :class="[{'first': !toggleImage, 'images': product.images.length > 1}]"
                     class="product-card-img-wrapper"
                     itemscope
                     itemtype="https://schema.org/ImageObject">
                    <img :alt="product.name + ' ' + product.article"
                         :class="{'hidden': toggleImage}"
                         :src="product.images[0]"
                         class="product-card-img"
                         height="346"
                         itemprop="contentUrl"
                         width="240"
                    />
                </div>
                <div v-else class="product-card-img-wrapper">
                    <img :alt="product.name + ' ' + product.article"
                         class="product-card-img"
                         height="346"
                         src=""
                         width="240"
                    />
                </div>
                <div v-if="product.images[1]"
                     :class="[{'second': toggleImage, 'images': product.images.length > 1}]"
                     class="product-card-img-wrapper">
                    <img :alt="product.name + ' ' + product.article"
                         :class="{'hidden': !toggleImage}"
                         :data-src="product.images[1]"
                         :loading="lazyLoad ? 'lazy' : ''"
                         class="lazyload product-card-img"
                         height="346"
                         :src="lazyLoad ? '' : product.images[1]"
                         width="240"
                    />
                </div>
            </div>

            <div class="product-card-badge-container">
                <div v-if="product.new" class="product-card-badge product-card-badge--new"><span>New</span></div>
                <div v-if="product.discount" class="product-card-badge product-card-badge--sale">
                    <span>-{{ product.discount }}%</span></div>
            </div>

            <div class="product-card-right-badges">
                <q-btn :class="{ active: isFavorite }" class="icon-wrapper"
                       flat
                       @click.prevent="switchFavorites()">
                    <span class="icon like"></span>
                    <q-tooltip anchor="top middle" self="bottom middle">
                        <p v-if="!isFavorite">Добавить в избранное</p>
                        <p v-if="isFavorite">Удалить из избранного</p>
                    </q-tooltip>
                </q-btn>
                <ComparisonBtn :product-id="product.id"/>
            </div>

            <span v-if="showArticle" class="product-card-vendor">{{ product.article }}</span>

            <div class="product-card-purchase">
                <div :class="{'product-card-price--sale' : hasDiscount}" class="product-card-price">
                    <span class="price-total">{{ totalPrice }}<span class="rub"> руб</span></span>
                    <span v-if="hasDiscount" class="price-old">{{ originalPrice }}<span class="rub"> руб</span></span>
                </div>
                <div class="product-card-buy" @click.prevent="buy">
                    <div :class="{'click': buyOnClick, 'in-cart': buyInCart}" class="button">
                        <span class="icon cart"></span>
                        <span class="icon ok"></span>
                    </div>
                </div>
            </div>
            <div class="product-card-title">
                <span class="product-card-title-category">{{ product.name }}</span>
            </div>
            <div class="product-rating">
                <div class="product-rating-stars">
                    <span v-for="i in 5" :class="{'fill': product.reviews && i <= Math.round(product.reviews.rating)}"
                          class="star icon"></span>&nbsp;({{
                        product.reviews ? product.reviews.count : 0
                    }})
                </div>
            </div>
            <div v-if="product.color && product.color.style" class="product-card-color">
                <span :style="product.color.style"></span>
                {{ product.color.label }}
            </div>
        </a>
        <div v-if="cardProduct.sizes && cardProduct.sizes.length && cardProduct.size_required" class="product-sizes">
            <span v-for="size in cardProduct.sizes"
                  :key="`size-${size}`">{{ size }}</span>
        </div>
        <div class="product-card-desc">
            <div class="product-card-desc-wrapper">
                <div v-if="cardProduct.sizes && cardProduct.sizes.length && cardProduct.size_required"
                     class="product-card-size">
                    <span v-for="size in cardProduct.sizes"
                          :class="{ 'active': sizeSelected(cardProduct.id, size) }"
                          @click.prevent="toggleSize({productId: cardProduct.id, size: size})">{{ size }}</span>
                </div>
                <div v-if="product.promo_code" class="product-card-promo">
                    Дополнительная скидка -{{ product.promo_code.discount }} по промокоду
                    <span>{{ product.promo_code.code }}</span>
                </div>
                <div v-if="!product.waiting_list" class="product-card-desc-actions">
                    <div v-if="cardProduct.status" class="product-card-buy" @click.prevent="buy">
                        <div :class="{'click': buyOnClick, 'in-cart': buyInCart}" class="button">
                            <span class="icon cart"></span>
                            <span class="icon ok"></span>
                        </div>
                    </div>
                    <div class="btn btn-outline" @click.prevent="viewDetails()">Быстрый просмотр</div>
                </div>
                <div v-if="product.waiting_list"
                     class="product-card-desc-actions justify-content-start">
                    <div class="product-card-buy m-0"
                         @click.prevent="deleteWaitingListProduct(product.id)">
                        <div class="bg-white btn-outline button">
                            <svg fill="none" height="17" viewBox="0 0 16 17" width="16"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M15.7011 2.84787C15.6379 2.78475 15.5571 2.75302 15.4587 2.75302H12.2003L11.4622 0.992187C11.3568 0.732029 11.167 0.510576 10.893 0.327793C10.6187 0.145047 10.3409 0.0537109 10.0598 0.0537109H6.68545C6.40435 0.0537109 6.12661 0.145047 5.85245 0.327793C5.57826 0.510576 5.38846 0.731992 5.28298 0.992187L4.54486 2.75302H1.2866C1.1881 2.75302 1.10737 2.78475 1.04406 2.84787C0.980945 2.91113 0.949219 2.99202 0.949219 3.09041V3.76533C0.949219 3.86372 0.980797 3.9446 1.04406 4.00776C1.10737 4.07099 1.18825 4.1026 1.2866 4.1026H2.2988V14.1411C2.2988 14.7247 2.464 15.222 2.79437 15.6331C3.12481 16.0445 3.522 16.25 3.98599 16.25H12.7592C13.2233 16.25 13.6205 16.0374 13.9509 15.6123C14.2812 15.1868 14.4463 14.6825 14.4463 14.0991V4.1026H15.4587C15.557 4.1026 15.6379 4.07099 15.7011 4.00776C15.7642 3.94464 15.796 3.86372 15.796 3.76533V3.09041C15.7961 2.99202 15.7642 2.91113 15.7011 2.84787ZM6.52733 1.51915C6.57649 1.45592 6.63629 1.41714 6.70657 1.40318H10.0492C10.1195 1.41725 10.1794 1.456 10.2285 1.51915L10.7348 2.75287H6.01064L6.52733 1.51915ZM13.0967 14.0991C13.0967 14.2537 13.0722 14.3961 13.0229 14.5261C12.9736 14.656 12.9226 14.751 12.87 14.8107C12.8171 14.8706 12.7805 14.9004 12.7592 14.9004H3.98603C3.96494 14.9004 3.92822 14.8706 3.87537 14.8107C3.8226 14.751 3.77159 14.656 3.72236 14.5261C3.6732 14.3961 3.6486 14.2536 3.6486 14.0991V4.1026H13.0967V14.0991H13.0967Z"
                                    fill="#333333"/>
                                <path
                                    d="M5.33543 12.8755H6.01024C6.10874 12.8755 6.18966 12.8439 6.25278 12.7807C6.3159 12.7173 6.34763 12.6366 6.34763 12.5381V6.46423C6.34763 6.36587 6.3159 6.28499 6.25278 6.22169C6.18948 6.15857 6.10878 6.12695 6.01024 6.12695H5.33543C5.23693 6.12695 5.15616 6.15853 5.09289 6.22169C5.0297 6.28499 4.99805 6.36587 4.99805 6.46423V12.5381C4.99805 12.6366 5.02959 12.7173 5.09289 12.7807C5.15616 12.8439 5.23693 12.8755 5.33543 12.8755Z"
                                    fill="#333333"/>
                                <path
                                    d="M8.0366 12.8755H8.71141C8.80988 12.8755 8.89076 12.8439 8.95385 12.7807C9.0173 12.7173 9.04873 12.6366 9.04873 12.5381V6.46423C9.04873 6.36587 9.01726 6.28499 8.95385 6.22169C8.89076 6.15857 8.80988 6.12695 8.71141 6.12695H8.0366C7.93821 6.12695 7.85733 6.15853 7.79406 6.22169C7.73076 6.28499 7.69922 6.36587 7.69922 6.46423V12.5381C7.69922 12.6366 7.73076 12.7173 7.79406 12.7807C7.85729 12.8439 7.93821 12.8755 8.0366 12.8755Z"
                                    fill="#333333"/>
                                <path
                                    d="M10.7339 12.8755H11.4086C11.5072 12.8755 11.5881 12.8439 11.6513 12.7807C11.7145 12.7173 11.7459 12.6366 11.7459 12.5381V6.46423C11.7459 6.36587 11.7145 6.28499 11.6513 6.22169C11.5881 6.15857 11.5072 6.12695 11.4086 6.12695H10.7339C10.6353 6.12695 10.5547 6.15853 10.4913 6.22169C10.4281 6.28499 10.3965 6.36587 10.3965 6.46423V12.5381C10.3965 12.6366 10.4281 12.7173 10.4913 12.7807C10.5547 12.8439 10.6353 12.8755 10.7339 12.8755Z"
                                    fill="#333333"/>
                            </svg>
                        </div>
                        <q-tooltip anchor="top middle" self="bottom middle">
                            <p>Удалить из листа ожидания</p>
                        </q-tooltip>
                    </div>
                    <span class="not-in-stock-label">Нет в наличии</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
import Confirm from './../Modals/Confirm';
import ComparisonBtn from "./ComparisonBtn.vue";
import _ from "lodash";

export default {
    name: 'ProductCard',
    components: {
        Confirm,
        ComparisonBtn
    },
    props: {
        lazyLoad: {
            type: Boolean,
            default: true
        },
        product: {
            type: Object,
            required: true,
        },
        promoCode: {},
        showArticle: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            cardProduct: {},
            toggleImage: false,
            selectedSizes: [],
            slide: 1,
            liked: false,
            productDetails: false,
            buyOnClick: false,
            buyInCart: false,
            first: true,
            second: false,
        }
    },
    watch: {
        modalSize(val) {
            if (!val && this.buyOnClick) {
                this.buyOnClick = false;
            }
        },
        product() {
            // reset to the first image
            this.toggleImage = false;
        }
    },
    created() {
        this.cardProduct = this.product;
    },
    methods: {
        ...mapMutations('product', [
            'clearSelection',
            'toggleSize',
            'showProductSizeModal',
            'setProduct',
            'showDetailModal',
            'setSelectedProductDetails',
            'setSelectedSizes'
        ]),
        ...mapActions({
            addProduct: 'cart/addProduct',
            deleteWaitingListProduct: 'product/deleteWaitingListProduct',
        }),
        productOption(slug) {
            return this.product.options.find(item => item.slug === slug);
        },
        viewDetails() {
            this.setProduct(this.cardProduct);

            if (!this.selectedProductDetails) {
                this.$store.dispatch('product/update', this.product.id);
            }
            this.showDetailModal();
        },
        mouseOver() {
            if (this.$q.platform.is.desktop && this.product.images.length > 1) {
                this.toggleImage = true;
            }
        },
        mouseLeave() {
            if (this.$q.platform.is.desktop && this.product.images.length > 1) {
                this.toggleImage = false;
            }
        },
        buy() {
            const _this = this;
            window.events.onClickBuy();
            this.setProduct(this.cardProduct);

            if (this.buyInCart) {
                window.location.href = '/cart/';
            } else {
                _this.buyOnClick = true;
                _this.addProduct({
                    productId: _this.product.id,
                    sizeRequired: _this.product.size_required
                }).catch(error => {
                    if (error.reason === 'no_size_selected') {
                        _this.showProductSizeModal();
                    } else if (_.has(error, 'response.data.product')) {
                        _this.buyOnClick = false;
                        _this.buyInCart = false;
                        _this.cardProduct = error.response.data.product;
                        _this.viewDetails();
                    }
                }).then(function (response) {
                    _this.buyOnClick = false;

                    if (response.status === 'success') {
                        _this.buyInCart = true;

                        setTimeout(function () {
                            _this.buyInCart = false;
                        }, 800);
                    }
                })
            }
        },
        swipe() {
            if (this.product.images.length > 1) {
                this.toggleImage = !this.toggleImage;
            }
        },
        switchFavorites() {
            this.$root.switchFavorites(this.product.id)
        }
    },
    computed: {
        ...mapGetters({
            categoryName: 'catalog/categoryName',
            brandName: 'catalog/brandName',
            productSizes: 'product/productSizes',
        }),
        ...mapGetters('product', ['sizeSelected']),
        ...mapState('catalog', [
            'promoCodeApplied',
        ]),
        ...mapState('product', [
            'modalDetail',
            'modalSize'
        ]),
        ...mapState('catalog', [
            'categoryId'
        ]),
        ...mapState('cart', [
            'cart'
        ]),
        promoCodeAppliedToProduct() {
            return !!(this.product.promo_code && this.product.promo_code.applied);
        },
        totalPrice() {
            return this.$root.priceFormat(this.promoCodeAppliedToProduct ? this.product.promo_code.final_price : this.product.selling_price);
        },
        originalPrice() {
            return this.$root.priceFormat(this.product.price);
        },
        hasDiscount() {
            return !!(this.product.discount || this.promoCodeAppliedToProduct);
        },
        selectedProductDetails() {
            return this.$store.getters["product/getSelectedProductDetails"](this.product.id);
        },
        isFavorite() {
            return this.$root.isFavorite(this.product.id)
        }
    }
}
</script>

